import { CalendarProps, InputNumberProps } from 'antd';
import { DatePickerType } from 'antd/es/date-picker';

import { InputPropsInterface } from '@/atoms/input';
import { DropDownOption } from '@/types/common';
import { Operator, PropertyType } from '@graphql/hooks-and-types';

export enum COMPONENT_TYPE {
  SELECT = 'select',
  CHECKBOX = 'checkbox',
  COLOR = 'color',
  DATE = 'date',
  DATETIME = 'datetime',
  TIME = 'time',
  EMAIL = 'email',
  FILE = 'file',
  IMAGE = 'image',
  NUMBER = 'number',
  PASSWORD = 'password',
  RADIO = 'radio',
  RANGE = 'range',
  TEL = 'tel',
  TEXT = 'text',
}

export enum FILTER_PREVIEW_TYPE {
  DEFAULT = 'default',
  LIST = 'list',
  CARD = 'card',
}

export interface LocationFilter {
  id: number;
  fieldName: string;
  label: string;
  componentType: COMPONENT_TYPE;
  options: DropDownOption[];
  maxLength: string;
  minValue: number;
  maxValue: number;
  preview: FILTER_PREVIEW_TYPE;
  placeholder: string;
  isMultiSelect: '1' | '0';
  secondaryOperator: Operator | null;
}
interface FilterComponentPropsInterface {
  filter: LocationFilter;
  value: any;
  handleChange: (value: any) => void;
}
export type FilterComponentInput = InputPropsInterface &
  InputNumberProps &
  FilterComponentPropsInterface &
  CalendarProps<DatePickerType>;
export interface LocationAvailableFilters {
  id: number;
  name: string;
  filters: LocationFilter[];
  propertyTypes: PropertyType[];
  amenities: { id: number; icon: string; name: string }[];
}

export interface AvailableFilterDropDown {
  name: string;
  placeholder: string;
  label: string;
  options: { label: string; value: string }[];
}
